import React from 'react';
import Sidebar from './Sidebar';
import adminMenuItems from '../config/adminMenu';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar items={adminMenuItems} type="admin" />
      <div className="lg:ml-64 min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
